import { render, staticRenderFns } from "./ChatInbox.vue?vue&type=template&id=728f97e4&scoped=true&"
import script from "./ChatInbox.vue?vue&type=script&lang=js&"
export * from "./ChatInbox.vue?vue&type=script&lang=js&"
import style0 from "./ChatInbox.vue?vue&type=style&index=0&id=728f97e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728f97e4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
